<template>
  <b-table show-empty striped hover class="aco-table" :items="groups" :fields="groupFields">
    <template v-slot:cell(show_details)="row">
      <router-link :to="{ name: 'GroupDetails', params: { id: row.item.groupId }}">
        <b-button size="sm" class="py-0">{{ $t('details') }}</b-button>
      </router-link>
    </template>

    <template v-slot:cell(ownerOrganizationNumber)="data">
      <div v-if="data.item.ownerOrganizationNumber != null">{{ data.item.ownerOrganizationNumber }}</div>
      <div v-else>{{ data.item.ownerUserId }}</div>
    </template>

  </b-table>
</template>

<script>

  import { mapGetters } from 'vuex'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'GroupList',
    extends: BaseComponent,

    computed: {
      ...mapGetters('groups', ['groups']),
      groupFields () {
        return [
          { key: 'name', label: this.$t('name'), tdClass: 'text-nowrap' },
          { key: 'groupSource', label: this.$t('source'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('groupSources', value) },
          { key: 'groupType', label: this.$t('type'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('groupTypes', value) },
          { key: 'grepCode', label: this.$t('grepFagkode'), tdClass: 'text-nowrap' },
          { key: 'ownerOrganizationNumber', label: this.$t('organization'), tdClass: 'text-nowrap' },
          { key: 'startDate', label: this.$t('startDate'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'endDate', label: this.$t('endDate'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'show_details', label: '' }
        ]
      }
    },
    mounted: function () {
      this.$store.dispatch('groups/getGroups')
    }
  }
</script>